import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { LocationListOperatorCell } from './location-list-operator.cell';
import { LocationListOperatorHeader } from './location-list-operator.header';

export const LocationListOperatorColumn: IdentifiedColumnDef<
  GatewayLocationModel,
  GatewayLocationModel['operator']
> = {
  enableSorting: false,
  header: LocationListOperatorHeader,
  cell: LocationListOperatorCell,
};
